import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axiosInstance from "../Help/AxiosLogicInstance"; // Adjust path if needed
import { toast } from "react-toastify";

const ProfilePage = () => {
  const [profile, setProfile] = useState(null);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
 useEffect(() => {
      window.scrollTo(0, 0);
    }, []);
  useEffect(() => {
    document.title = "Profile - MedEngage";
  }, []);
  
  // Validate token on component mount
  useEffect(() => {
    const token = localStorage.getItem("token");
    if (!token) {
      // No token found, redirect to home
      toast.error("Please login to access your profile");
      navigate("/");
      return;
    }

    // Validate token with API - using POST method as required by the endpoint
    const studentId = localStorage.getItem("StudentId");
    axiosInstance.post(`/api/Student/ValidateToken`, { 
      StudentId: studentId,
      Token: token
    })
      .then(res => {
        if (res.data.Status === "200") {
          // Check if token is active
          if (!res.data.Data.Isactive) {
            // Token inactive, clear storage and redirect
            localStorage.removeItem("token");
            localStorage.removeItem("StudentId");
            toast.error("Please login again, your session has expired");
            navigate("/");
          }
        } else {
          // Invalid token response, redirect
          localStorage.removeItem("token");
          localStorage.removeItem("StudentId");
          toast.error("Authentication failed, please login again");
          navigate("/");
        }
      })
      .catch(error => {
        console.error("Token validation error:", error);
        toast.error("Authentication error, please login again");
        localStorage.removeItem("token");
        localStorage.removeItem("StudentId");
        navigate("/");
      });
  }, [navigate]);

  useEffect(() => {
    const studentId = localStorage.getItem("StudentId");
    if (!studentId) {
      setLoading(false);
      return;
    }

    axiosInstance
      .get(`/api/Student/GetStudentProfile?studentId=${studentId}`)
      .then((res) => {
        if (res.data.Status === "200") {
          setProfile(res.data.Data);
        } else {
          setProfile(null);
        }
      })
      .catch(() => {
        setProfile(null);
      })
      .finally(() => {
        setLoading(false); // ✅ hide loader only after API resolves
      });
  }, []);

  const handleResetPassword = () => {
    navigate("/changepassword");
  };

const DetailRow = ({ label, value, verified = false }) => (
  <div className="d-flex flex-column flex-sm-row justify-content-between align-items-start align-items-sm-center py-2 border-bottom border-light">
    <div className="detail-row-label fw-semibold text-dark mb-1 mb-sm-0">
      {label}:
    </div>
    <div className="detail-row-value d-flex align-items-center flex-wrap">
      <span className="text-dark">{value}</span>
      {verified && (
        <span className="badge bg-success-subtle text-success rounded-pill ms-2 mt-1 mt-sm-0">
          Verified
        </span>
      )}
    </div>
  </div>
);


  if (loading) {
    return (
      <div
        className="position-fixed top-0 start-0 w-100 h-100 d-flex justify-content-center align-items-center bg-dark bg-opacity-50"
        style={{ zIndex: 9999 }}
      >
        <div className="custom-spinner"></div>
      </div>
    );
  }

  if (!profile) {
    return (
      <div className="container py-5 text-center">
        <h5>Profile not found.</h5>
      </div>
    );
  }

  return (
    <section className="ul-about ul-section-spacing px-3 py-5">
      <div className="container my-5">
        <div className="row g-4 justify-content-center">
          {/* Profile Card */}
          <div className="col-12 col-md-10 col-lg-6 mx-auto">
            <div className="card profile-card profile-img-md shadow-sm rounded-4 h-100">
              <div className="card-body p-4 text-start">
                <h5 className="fw-bold text-dark mb-1">Personal Details</h5>
                <DetailRow label="Full name" value={profile.UserName} />
                <DetailRow label="Date of Birth" value={profile.UserDob} />
                <DetailRow label="Address" value={profile.Address} />
                <DetailRow label="Phone Number" value={profile.MobileNo} />
                <DetailRow label="Email" value={profile.EmailID} />
                <DetailRow label="Institute" value={profile.Institution} />
                <DetailRow label="Year" value={profile.InstitutionYear} />
                <DetailRow label="Credentials" value={profile.Qualification} />
              </div>
            </div>
          </div>

          {/* Membership / System Info */}
          <div className="col-12 col-md-10 col-lg-6 mx-auto">
            <div className="profile-card shadow-sm rounded-4 h-100">
              <div className="card-body p-4">
                <h5 className="card-title fw-semibold text-dark mb-4">
                  Membership & System Info
                </h5>
                <DetailRow label="Student ID" value={profile.StudentId} />
                <DetailRow label="Membership Status" value="Active Member" />
                <DetailRow
                  label="Account Verification"
                  value="Verified"
                  verified
                />
                <DetailRow label="Language Preference" value="English" />
                <DetailRow
                  label="Time Zone"
                  value="IST (Indian Standard Time)"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ProfilePage;
